<template>
    <!--    公共警告框-->
    <el-dialog :title="title" :visible.sync="dialogVisible"  width="420px" :modal-append-to-body="false">
        <!-- 内容 -->
        <div class="content">
            <i :class="confIcon"></i>
            <span>{{confText}}</span>
        </div>
        <div slot="footer">
            <el-button type="primary" plain @click="cancelConfirm">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "index",
        props:{
            title:{
                type: String,
                default:'确认弹窗'
            },
            confText:{
                type: String,
                default:'确定要删除表吗？该操作不可恢复'
            },
            confIcon:{
                type: String,
                default:'el-icon-warning'
            },
        },
        data(){
            return{
              dialogVisible:false,
              id:''
            }
        },
        methods:{
            handleConfirm(){
                this.dialogVisible = false
                this.$emit('handleConfirm',this.id)
            },
            cancelConfirm(){
                this.dialogVisible = false
                this.$emit('cancelConfirm')
            }
        }
    }
</script>

<style scoped lang="scss">
.content{
    font-size: 15px;
    i{
        font-size: 20px;
        color: rgb(255,150,62);
    }
}
</style>
